import { render, staticRenderFns } from "./ClientBenefits.vue?vue&type=template&id=7bb9e830&scoped=true&"
import script from "./ClientBenefits.vue?vue&type=script&lang=js&"
export * from "./ClientBenefits.vue?vue&type=script&lang=js&"
import style0 from "./ClientBenefits.vue?vue&type=style&index=0&id=7bb9e830&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb9e830",
  null
  
)

export default component.exports